export const listLocationsByAppInstance = /* GraphQL */ `
  query ListLocationsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const listPointSellsByAppInstance = /* GraphQL */ `
  query ListPointSellsByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPointSellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointSellsByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const listRentCategoriesByProductType = /* GraphQL */ `
  query ListRentCategoriesByProductType(
    $appInstance: String
    $mobVersion: Int
    $productType: ProductType
  ) {
    listCategoriesByProductType(
      appInstance: $appInstance
      mobVersionProductType: {
        eq: { mobVersion: $mobVersion, productType: $productType }
      }
    ) {
      items {
        title
        description
        orderNumber
        products {
          items {
            id
            mobVersion
            title
            description
            rentProductType
            rentAvailabilityMode
            images
            sizes
            deposit
            skill {
              id
              mssId
              title
              description
            }
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            defaultLessonLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            locations {
              items {
                location {
                  id
                  mssId
                  groups
                  appInstance
                  title
                  description
                }
              }
            }
            priceTables {
              numberOfPersons
              priceListType
              dphPercent
              price1
              price2
              price3
              price4
              price5
              price6
              price7
              price8
              price9
              price10
              price11
              price12
              price13
              price14
              price15
              price16
              price17
              price18
              price19
              price20
              priceEveryOther
            }
            sets {
              items {
                set {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const listArticlesByProductAndPointSell = /* GraphQL */ `
  query ListArticlesByProductAndPointSell(
    $productId: ID
    $pointSellId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticlesByProductAndPointSell(
      productId: $productId
      pointSellId: $pointSellId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          defaultLessonLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
        }
      }
      nextToken
    }
  }
`;

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      mobVersion
      title
      description
      appInstance
      images
      sizes
      deposit
      rentProductType
      rentAvailabilityMode
      skill {
        id
        mssId
        title
        description
      }
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      defaultLessonLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price1
        price2
        price3
        price4
        price5
        price6
        price7
        price8
        price9
        price10
        price11
        price12
        price13
        price14
        price15
        price16
        price17
        price18
        price19
        price20
        priceEveryOther
      }
      sets {
        items {
          id
          set {
            id
            title
            products {
              items {
                product {
                  id
                  title
                  description
                  images
                  rentProductType
                }
              }
            }
            priceTables {
              priceListType
              numberOfPersons
              dphPercent
              price1
              price2
              price3
              price4
              price5
              price6
              price7
              price8
              price9
              price10
              price11
              price12
              price13
              price14
              price15
              price16
              price17
              price18
              price19
              price20
              priceEveryOther
            }
          }
          product {
            id
            title
            description
            sizes
            deposit
            images
            rentProductType
          }
        }
      }
    }
  }
`;

// nepouziva se
export const getSet = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
      id
      mobVersion
      title
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price1
        price2
        price3
        price4
        price5
        price6
        price7
        price8
        price9
        price10
        price11
        price12
        price13
        price14
        price15
        price16
        price17
        price18
        price19
        price20
        priceEveryOther
      }
      products {
        items {
          product {
            id
            title
            description
            sizes
            deposit
            rentProductType
            rentAvailabilityMode
          }
        }
      }
    }
  }
`;

export const getOrderr = /* GraphQL */ `
  query GetOrderr($id: ID!) {
    getOrderr(id: $id) {
      id
      orderrNumber
      mobVersion
      price
      priceWithoutDph
      dph
      itemsCount
      expireAt
      createdAt
      updatedAt
      bookingState
      groups
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      appInstance
      client {
        id
        groups
        appInstance
        mssId
        cognitoId
        name
        surname
        email
        phone
        documentType
        documentNumber
        documentValidTo
        companyName
        ic
        dic
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          groups
          appInstance
          mssId
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          dph
          dphPercent
          orderr {
            id
            price
          }
          subjectProfile {
            name
            shoeSize
            rentAbilityLevel
            gender
            age
            weight
            height
          }
          product {
            id
            title
            description
            productType
            rentAvailabilityMode
          }
          set {
            id
            title
            description
          }
          orderrItems {
            items {
              id
              language
              skillLevelClient
              sameInstructorRequired
              numberOfHoursRequired
              product {
                id
                title
                description
                deposit
                skill {
                  id
                  mssId
                  title
                  description
                }
              }
              article {
                id
                title
                description
                size
                sizeUnit
                pointSell {
                  id
                  title
                }
              }
              lessons {
                timeFrom
                timeTo
                mssWorkDayId
              }
            }
          }
        }
      }
    }
  }
`;

export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      mobVersion
      groups
      appInstance
      mssId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      owner
      orderr {
        id
      }
    }
  }
`;

// uspornejsi varianta bez nacitani atributu content, ktery muze byt potencionalne celkem objemny
export const listStaticContentByAppInstance = /* GraphQL */ `
  query ListStaticContentByAppInstance(
    $appInstance: String
    $mobVersion: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaticContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaticContentByAppInstance(
      appInstance: $appInstance
      mobVersion: $mobVersion
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mobVersion
        groups
        appInstance
        title
        icon
        isExternal
        linkUrl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const createOrderrItem = /* GraphQL */ `
  mutation CreateOrderrItem($input: CreateOrderrItemInput!) {
    createOrderrItem(input: $input) {
      id
    }
  }
`;

export const createOrderrDraft = /* GraphQL */ `
  mutation CreateOrderrDraft($input: CreateOrderrDraftIn!) {
    createOrderrDraft(input: $input) {
      id
    }
  }
`;

export const addToCart = /* GraphQL */ `
  mutation AddToCart($input: AddToCartIn!) {
    addToCart(input: $input) {
      id
    }
  }
`;

export const removeFromCart = /* GraphQL */ `
  mutation RemoveFromCart($orderrItemGroupId: ID!) {
    removeFromCart(orderrItemGroupId: $orderrItemGroupId) {
      id
    }
  }
`;

export const updateOrderrPickupAndPaymentInfo = /* GraphQL */ `
  mutation UpdateOrderrPickupAndPaymentInfo(
    $orderrId: ID!
    $datePickUp: AWSDateTime!
    $paymentMethod: PaymentMethod!
  ) {
    updateOrderrPickupAndPaymentInfo(
      orderrId: $orderrId
      datePickUp: $datePickUp
      paymentMethod: $paymentMethod
    ) {
      id
    }
  }
`;

export const checkoutOrderr = /* GraphQL */ `
  mutation CheckoutOrderr($orderrId: ID!, $subjectIn: SubjectIn!) {
    checkoutOrderr(orderrId: $orderrId, subjectIn: $subjectIn) {
      id
    }
  }
`;
